import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=baaffd12&scoped=true&"
import script from "./HelpButton.vue?vue&type=script&lang=js&"
export * from "./HelpButton.vue?vue&type=script&lang=js&"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=baaffd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaffd12",
  null
  
)

export default component.exports